import api from '../../api/employee';

export default {
    state: {
        employeeForm: {
            step1: {
                stage: 1,
                step: 1,
                employees_name: "",
                employees_surname: "",
                employees_country: "",
                employees_city: "",
                birthday: "",
                type_work: {
                    type: "",
                    employment: ""
                },
                equipment: []
            },
            step2: {
                stage: 1,
                step: 2,
                experience: "",
                native_language: {},
                employees_language: {},
            },
            step3: {
                stage: 1,
                step: 3,
                skype: "",
                employees_telcode: "",
                employees_number: "",
                date: "",
                e_time: ""
            },
            step4: {
                stage: 2,
                step: 3,
                home_address: "",
                identity: "",
            },
        },
    },
    getters: {
        getEmployeeForm: (state) => state.employeeForm,
    },
    mutations: {
        SET_EMPLOYEE_FORM_DATA(state, payload) {
            const result = {
                step1: {},
                step2: {},
                step3: {},
                step4: {},
            };

            const {
                step1,
                step2,
                step3,
                step4,
            } = state.employeeForm;

            Object.keys(step1).map(item => {
                if (payload[item]) {
                    result.step1[item] = payload[item];
                } else {
                    result.step1[item] = step1[item];
                }
            });

            Object.keys(step2).map(item => {
                if (payload[item]) {
                    result.step2[item] = payload[item];
                } else {
                    result.step2[item] = step2[item];
                }
            });

            Object.keys(step3).map(item => {

                if (payload[item]) {
                    result.step3[item] = payload[item];
                } else {
                    result.step3[item] = step3[item];
                }
            });

            Object.keys(step4).map(item => {
                if (payload[item]) {
                    result.step4[item] = payload[item];
                } else {
                    result.step4[item] = step4[item];
                }
            });

            result.step1.step = 1;
            result.step2.step = 2;
            result.step3.step = 3;
            result.step4.step = 3;
            result.step4.stage = 2;

            state.employeeForm = result;
        },
    },
    actions: {
        fetchEmployee({
            commit,
            dispatch
        }) {
            api.get().then(({
                data: {
                    data: {
                        employee
                    }
                },
                status
            }) => {
                if (status === 200) {
                    dispatch('setEmployeeFormStepActiveData', ++employee.step);
                    dispatch('setEmployeeData', employee);
                    commit('SET_EMPLOYEE_FORM_DATA', employee);
                }
            });
        }
    },
};